import { ShadowTestResultResponse } from "../lusca-search-api/generated-src";

export type ShadowTestResultStatus = "PASS" | "FAIL" | "BLOCKED";
export type ShadowTestResultResponseWithCompat = ShadowTestResultResponse & {
  resultStatus?: ShadowTestResultStatus;
  resultStatusMessage?: string;
};

export const getShadowTestResultStatus = (
  result: Pick<ShadowTestResultResponseWithCompat, "passed" | "resultStatus">
): ShadowTestResultStatus => {
  if (result.resultStatus) return result.resultStatus;

  // TODO(TRACK-11109): Remove this compatibility fallback after all Cyberman
  // records and API responses contain resultStatus.
  return result.passed ? "PASS" : "FAIL";
};

export const getShadowTestStatusIndicatorType = (
  status: ShadowTestResultStatus
): "success" | "error" | "warning" => {
  if (status === "PASS") return "success";
  if (status === "BLOCKED") return "warning";
  return "error";
};
